import { render, staticRenderFns } from "./Clientvisit.vue?vue&type=template&id=b2814ace"
import script from "./Clientvisit.vue?vue&type=script&lang=js"
export * from "./Clientvisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports